<template>
  <div class="horizontal-container">
    <div ref="scroll" class="scroll-wrapper">
      <div class="scroll-content" transition="v-fab-transition">
        <v-tabs
          :value="current"
          background-color="#fff"
          color="#1976D2"
          center-active
          show-arrows
        >
          <v-tab
            v-for="(tab, index) in tabList"
            :key="index"
            @click="changeMenu(tab)"
            @contextmenu.prevent.native="openMenu($event, index)"
          >
            <span>{{ tab.label }}</span>
            <span
              v-show="tabList.length > 1"
              class="padding-box"
              @click.stop="handleClose(tab)"
            >
              <img
                class="close-icon"
                :src="current === index ? activeCloseIcon : closeIcon"
              />
            </span>
          </v-tab>
        </v-tabs>
      </div>
    </div>
    <v-menu
      :value="menuVisible"
      :position-y="64"
      :position-x="nudgeLeft"
      :return-value="false"
      @input="handleInput"
    >
      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index">
          <v-list-item-title class="cursor" @click="handleClick(item)">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <BaseDialog
      :visible.sync="visible"
      content="确认关闭该页面？系统可能不会保存您所作的更改"
      @handleConfirm="handleConfirm"
    />
  </div>
</template>

<script>
import { ref } from 'vue'
import useNavigation from '@/hooks/useNavigation'
import { useRouter } from '@/utils'
import BaseDialog from '@/components/BaseDialog.vue'
import closeIcon from '@/assets/images/svg/close.svg'
import activeCloseIcon from '@/assets/images/svg/close-active.svg'

export default {
  components: { BaseDialog },
  setup() {
    const { route, router } = useRouter()

    const {
      // activeFullPath,
      tabList,
      current,

      visible,
      selectMenu,
      changeMenu,
      handleClose,
      handleConfirm,

      handleCloseOtherTab,
      handleCloseRightTab,
      handleCloseLeftTab,
    } = useNavigation(route, router)

    const items = ref([
      { title: '关闭', type: 'close' },
      { title: '关闭其他标签页', type: 'closeOther' },
      { title: '关闭左侧标签页', type: 'closeRight' },
      { title: '关闭右侧标签页', type: 'closeLeft' },
    ])
    const menuVisible = ref(false)
    const nudgeLeft = ref(0)
    const currentRightClickIndex = ref(0)
    const openMenu = (e, index) => {
      nudgeLeft.value = e.x - 72
      menuVisible.value = false // true todo 暂时不使用右键菜单功能
      currentRightClickIndex.value = index
    }
    const handleInput = () => {
      menuVisible.value = false
    }
    const handleClick = (item) => {
      const currentTab = tabList.value[currentRightClickIndex.value]
      switch (item.type) {
        case 'close':
          handleClose(currentTab)
          break
        case 'closeOther':
          handleCloseOtherTab(currentRightClickIndex.value)
          break
        case 'closeRight':
          handleCloseLeftTab(currentRightClickIndex.value)
          break
        case 'closeLeft':
          handleCloseRightTab(currentRightClickIndex.value)
          break
        default:
          break
      }
    }

    return {
      // activeFullPath,
      tabList,
      current,
      activeCloseIcon,
      closeIcon,

      visible,
      selectMenu,
      openMenu,
      handleClose,
      handleConfirm,

      changeMenu,
      items,
      menuVisible,
      nudgeLeft,
      handleInput,
      handleClick,
    }
  },
}
</script>
<style lang="scss" scoped>
.horizontal-container {
  .scroll-wrapper {
    max-width: calc(100vw - 500px);
    position: relative;
  }
  .scroll-content {
    height: 64px;
    :deep(.v-tabs, ) {
      height: 100%;
    }
    :deep(.v-item-group) {
      height: 100%;
    }
  }
}
.padding-box {
  padding: 8px 11px;
  margin-left: 4px;
  &:hover {
    background: #eeeeee;
    border-radius: 50%;
  }
}

.close-icon {
  width: 12px;
  height: 12px;
}
.v-list-item:hover {
  background-color: rgba(94, 86, 105, 0.07);
}
</style>
